import React from 'react';

import puceTemoignageFormulaire from './assets/webyoo/media/puce-temoignage-formulaire.png';


export default () => (
  <div id="Screen_4">
    <div class="gp-content1">
      <h2 class="gp-title">
        JE TÉMOIGNE D’UN IMPACT DU DÉRÈGLEMENT CLIMATIQUE SUR MA VIE
      </h2>
      <img src={puceTemoignageFormulaire} alt="" />
      <p>
        Cette carte rend visible les impacts du dérèglement climatique en France.
        C’est grâce aux témoignages de chacune et chacun d’entre nous qu’elle pourra montrer
        l’urgence d’agir en France. Vous aussi apportez votre contribution !
      </p>
    </div>
  </div>
);
